var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert--error"},[_vm._v("Мы временно приостановили прием заказов с сайта из-за высокой нагрузки, зайдите, пожалуйста, позднее.")])
}
var staticRenderFns = []

export { render, staticRenderFns }